import { createFileRoute } from "@tanstack/react-router";
import { SessionLogDetail } from "@/features/logs";

/**
 * ONE SESSION OUT OF HISTORY — pushed from the list, one segment deeper, so the shell plays
 * the stack transition rather than a cross-fade (`navDirection` reads path depth).
 *
 * The screen owns its own header bar and its own footer, the way the strength log and the
 * block screen do, so the route renders it whole rather than putting a title above it.
 */
export const Route = createFileRoute("/_app/history/$id")({
  component: SessionLogScreen,
});

function SessionLogScreen() {
  const { id } = Route.useParams();

  return <SessionLogDetail logId={id} />;
}
